import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { LoadingAkanaService } from 'src/app/services/loading-akana.service';
import { LogoutService } from 'src/app/services/logout.service';

/**
 * Componente para el header en versión escritorio
 */
@Component({
  standalone: false,
  selector: 'app-header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrls: ['./header-desktop.component.scss']
})
export class HeaderDesktopComponent implements OnInit {

  /**
   * Guarda si se muestra o no el perfil
   */
  showProfile: boolean;

  /**
   * Crea una instancia para header desktop component.
   * @param route 
   * @param commonService 
   * @param logout 
   * @param l 
   */
  constructor(private route: Router, private commonService: CommonsService, private logout: LogoutService, private l: LoadingAkanaService) { }

  /**
   * on init - inicializa showProfile en funcion de la propiedad del storage
   */
  ngOnInit() {
    this.showProfile = (sessionStorage.getItem('A_profile') === 'Y_P') ? true : false;
  }

  /**
   * Funcion para saber cual es la ruta actual
   * @param route 
   * @returns  
   */
  isCurrent(route) {
    return this.route.url.includes(route) ? true : false;
  }

  /**
   * Redirige a la página correspondiente
   * @param route 
   * @param [disc] 
   */
  goToURL(route, disc?) {
    if (route && !disc) {
      this.commonService.eventsAnalitics('click', 'Menu', route);
      this.route.navigateByUrl('global-position/' + route);
    } else if (route && disc) {
      this.l.setShowLoading(true);
      this.commonService.eventsAnalitics('click', 'Navbar Menu', 'Log Out');
      this.logout.logOutService().subscribe(d => {
        setTimeout(() => { this.l.setShowLoading(false); }, 300);
        if (d) {
          sessionStorage.clear();
          this.route.navigateByUrl('home');
        }
      });
    } else {
      this.commonService.eventsAnalitics('click', 'Menu', 'main');
      this.route.navigateByUrl('global-position');
    }
  }

  /**
   * Guarda en el pool de navegacion la ruta actual
   */
  saveUrl() {
    this.commonService.setCurrentUrl(this.route.url);
  }

  /**
   * Redirige a la home
   */
  goToHome() {
    // this.route.navigateByUrl('/home');
  }
}
